<style lang="scss" scoped>
.step{
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  height: 434px;
  width: 674px;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-content: center;
}
.successResult,.failResult{
  align-self: center;
}
.successResult{
  font-weight: bold;
  color: #7bbcff;
}
.failResult{
  font-weight: bold;
  color: red;
}

</style>
<template>
  <div class="step">
    <p class="successResult" v-if="checkPassed || is_online === 1">恭喜您通过了本次考前测试，请点击完成提交结果。</p>
  </div>
</template>
<script>


export default {
  data() { return {}; },
  methods: {

  },

  components: {},
  created() {
    console.log('done');
  },
  mounted() {
    console.log(this.deviceStatus);
  },
  props: {
    deviceStatus: {
      type: Object,
    },
    checkPassed: {
      type: [Boolean],
    },
    is_online: {
      type: [String,Number],
    },
  },
  watch: {},
};
</script>
